export default "__VITE_ASSET__f6ebddf2__"